import { CustomerDetails, CustomizationDetails, FormList } from '@components';
import React, { useContext, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { NumberParam, useQueryParams } from 'use-query-params';
import { EnumStringParam } from 'utils/params';
import { AuthContext } from 'auth/context';

type Props = RouteComponentProps<{ id: string }>;

const CustomerPage: React.FC<Props> = ({ match, history }) => {
  const id = +match.params.id;
  const [{ cId: name, mode }, setQuery] = useQueryParams({
    cId: NumberParam,
    mode: EnumStringParam(['show', 'edit'], 'show')
  });
  const query_mode = mode ? 'replaceIn' : 'pushIn';
  const { user } = useContext(AuthContext);
  const editable = user?.role === 'User';

  useEffect(() => {
    if (!editable && mode === 'edit') {
      setQuery({ mode: 'show' }, query_mode);
    }
  }, [editable, mode, query_mode, setQuery]);

  return (
    <div>
      {mode !== 'edit' && <CustomerDetails id={id} />}
      <br />
      {name ? (
        <CustomizationDetails
          editable={editable}
          formId={name}
          customerId={id}
          edit={mode === 'edit'}
          onBack={() => {
            setQuery({ mode: undefined, cId: undefined });
            history.goBack();
          }}
          onEdit={() => setQuery({ mode: 'edit' }, query_mode)}
          onSave={() => setQuery({ mode: 'show' }, query_mode)}
        />
      ) : (
        <FormList
          editable={editable}
          customerId={id}
          onSelect={form =>
            setQuery({ mode: 'show', cId: form.id }, query_mode)
          }
          onEdit={form => setQuery({ mode: 'edit', cId: form.id }, query_mode)}
        />
      )}
    </div>
  );
};

export default CustomerPage;
